import Yeekee from "../assets/lotteryType/yeekee.png";
import Yeekee5G from "../assets/lotteryType/yeekee5g.png";
import Yeekee12 from "../assets/lotteryType/yeekee12.png";
import Gov from "../assets/lotteryType/gov.png";
import Gsb from "../assets/lotteryType/GSB.png";
import Baac from "../assets/lotteryType/BAAC.png";
import Vietnam from "../assets/lotteryType/vietnam.png";
import China from "../assets/lotteryType/china.png";
import Egypt from "../assets/lotteryType/egypt.png";
import Germany from "../assets/lotteryType/germany.png";
import Hongkong from "../assets/lotteryType/hong-kong.png";
import India from "../assets/lotteryType/india.png";
import Japan from "../assets/lotteryType/japan.png";
import Laos from "../assets/lotteryType/laos.png";
import Malaysia from "../assets/lotteryType/malaysia.png";
import Russia from "../assets/lotteryType/russia.png";
import Singapore from "../assets/lotteryType/singapore.png";
import SouthKorea from "../assets/lotteryType/south-korea.png";
import Taiwan from "../assets/lotteryType/taiwan.png";
import Uk from "../assets/lotteryType/uk.png";
import Usa from "../assets/lotteryType/usa.png";
import Default from "../assets/lotteryType/default.png";
import StockMarket from "../assets/lotteryType/StockMarket.png";
import Thai from "../assets/lotteryType/thailand.png";

const getIconHuay = (data) => {
  switch (data) {
    case "จับยี่กี":
      return Yeekee;
    case "จับยี่กี 5G":
      return Yeekee5G;
    case "จับยี่กี 12 ราศี":
      return Yeekee12;
    case "หวยรัฐบาลไทย":
      return Gov;
    case "หวยออมสิน":
      return Gsb;
    case "หวยออมสินพิเศษ 1 ปี":
      return Gsb;
    case "หวยออมสินพิเศษ 2 ปี":
      return Gsb;
    case "หวย ธกส":
      return Baac;
    case "หวยฮานอย":
      return Vietnam;
    case "หวยฮานอย VIP":
      return Vietnam;
    case "หวยฮานอยพิเศษ":
      return Vietnam;
    case "หวยฮานอย 5G":
      return Vietnam;
    case "หวยฮานอย 4D":
      return Vietnam;
    case "หวยมาเลย์":
      return Malaysia;
    case "หวยลาว":
      return Laos;
    case "หวยลาวสตาร์":
      return Laos;
    case "หวยลาวจำปาศักดิ์":
      return Laos;
    case "หวยหุ้นจีนรอบเช้า":
      return China;
    case "หวยหุ้นจีนรอบบ่าย":
      return China;
    case "หวยหุ้นฮั่งเส็งรอบเช้า":
      return Hongkong;
    case "หวยหุ้นฮั่งเส็งรอบบ่าย":
      return Hongkong;
    case "หวยหุ้นนิเคอิรอบเช้า":
      return Japan;
    case "หวยหุ้นนิเคอิรอบบ่าย":
      return Japan;
    case "หวยหุ้นดาวน์โจน":
      return Usa;
    case "หวยหุ้นเกาหลี":
      return SouthKorea;
    case "หวยหุ้นไต้หวัน":
      return Taiwan;
    case "หวยหุ้นเยอรมัน":
      return Germany;
    case "หวยหุ้นรัสเซีย":
      return Russia;
    case "หวยหุ้นสิงคโปร์":
      return Singapore;
    case "หวยหุ้นอังกฤษ":
      return Uk;
    case "หวยหุ้นอินเดีย":
      return India;
    case "หวยหุ้นอียิปต์":
      return Egypt;
    case "หวยหุ้น":
      return StockMarket;
    case "หวยไทย":
      return Thai;
    case "จับยี่กี SUPER":
      return Yeekee;
    case "จับยี่กี 5G SUPER":
      return Yeekee5G;
    case "จับยี่กี 12 ราศี SUPER":
      return Yeekee12;
    case "หวยรัฐบาลไทย SUPER":
      return Gov;
    case "หวยออมสิน SUPER":
      return Gsb;
    case "หวย ธกส SUPER":
      return Baac;
    case "หวยฮานอย SUPER":
      return Vietnam;
    case "หวยฮานอย VIP SUPER":
      return Vietnam;
    case "หวยฮานอยพิเศษ SUPER":
      return Vietnam;
    case "หวยฮานอย 5G SUPER":
      return Vietnam;
    case "หวยฮานอย 4D SUPER":
      return Vietnam;
    case "หวยมาเลย์ SUPER":
      return Malaysia;
    case "หวยลาว SUPER":
      return Laos;
    case "หวยลาวสตาร์ SUPER":
      return Laos;
    case "หวยลาวจำปาศักดิ์ SUPER":
      return Laos;
    case "หวยหุ้นจีนรอบเช้า SUPER":
      return China;
    case "หวยหุ้นจีนรอบบ่าย SUPER":
      return China;
    case "หวยหุ้นฮั่งเส็งรอบเช้า SUPER":
      return Hongkong;
    case "หวยหุ้นฮั่งเส็งรอบบ่าย SUPER":
      return Hongkong;
    case "หวยหุ้นนิเคอิรอบเช้า SUPER":
      return Japan;
    case "หวยหุ้นนิเคอิรอบบ่าย SUPER":
      return Japan;
    case "หวยหุ้นดาวน์โจน SUPER":
      return Usa;
    case "หวยหุ้นเกาหลี SUPER":
      return SouthKorea;
    case "หวยหุ้นไต้หวัน SUPER":
      return Taiwan;
    case "หวยหุ้นเยอรมัน SUPER":
      return Germany;
    case "หวยหุ้นรัสเซีย SUPER":
      return Russia;
    case "หวยหุ้นสิงคโปร์ SUPER":
      return Singapore;
    case "หวยหุ้นอังกฤษ SUPER":
      return Uk;
    case "หวยหุ้นอินเดีย SUPER":
      return India;
    case "หวยหุ้นอียิปต์ SUPER":
      return Egypt;
    case "หวยหุ้น SUPER":
      return StockMarket;
    case "หวยไทย SUPER":
      return Thai;
    case "หวย JACKPOT 6 ตัว":
      return Gov;
    case "หวย JACKPOT 4-5 ตัว":
      return Gov;
    default:
      return Default;
  }
};

const getColorCard = (name) => {
  switch (name) {
    case "จับยี่กี":
      return "bg-[#ff943e]";
    case "จับยี่กี 5G":
      return "bg-[#ff943e]";
    case "จับยี่กี 12 ราศี":
      return "bg-[#ff943e]";
    case "หวยรัฐบาลไทย":
      return "bg-[#3e8bff]";
    case "หวยออมสิน":
      return "bg-[#e73583]";
    case "หวยออมสินพิเศษ 1 ปี":
      return "bg-[#e73583]";
    case "หวยออมสินพิเศษ 2 ปี":
      return "bg-[#e73583]";
    case "หวย ธกส":
      return "bg-[#4343a5]";
    case "หวยฮานอย":
      return "bg-[#01a163]";
    case "หวยฮานอย VIP":
      return "bg-[#01a163]";
    case "หวยฮานอยพิเศษ":
      return "bg-[#01a163]";
    case "หวยฮานอย 5G":
      return "bg-[#01a163]";
    case "หวยฮานอย 4D":
      return "bg-[#01a163]";
    case "หวยมาเลย์":
      return "bg-[#01a163]";
    case "หวยลาว":
      return "bg-[#01a163]";
    case "หวยลาวสตาร์":
      return "bg-[#01a163]";
    case "หวยลาวจำปาศักดิ์":
      return "bg-[#01a163]";
    case "หวยหุ้นจีนรอบเช้า":
      return "bg-[#a63acd]";
    case "หวยหุ้นจีนรอบบ่าย":
      return "bg-[#a63acd]";
    case "หวยหุ้นฮั่งเส็งรอบเช้า":
      return "bg-[#a63acd]";
    case "หวยหุ้นฮั่งเส็งรอบบ่าย":
      return "bg-[#a63acd]";
    case "หวยหุ้นนิเคอิรอบเช้า":
      return "bg-[#a63acd]";
    case "หวยหุ้นนิเคอิรอบบ่าย":
      return "bg-[#a63acd]";
    case "หวยหุ้นดาวน์โจน":
      return "bg-[#a63acd]";
    case "หวยหุ้นเกาหลี":
      return "bg-[#a63acd]";
    case "หวยหุ้นไต้หวัน":
      return "bg-[#a63acd]";
    case "หวยหุ้นเยอรมัน":
      return "bg-[#a63acd]";
    case "หวยหุ้นรัสเซีย":
      return "bg-[#a63acd]";
    case "หวยหุ้นสิงคโปร์":
      return "bg-[#a63acd]";
    case "หวยหุ้นอังกฤษ":
      return "bg-[#a63acd]";
    case "หวยหุ้นอินเดีย":
      return "bg-[#a63acd]";
    case "หวยหุ้นอียิปต์":
      return "bg-[#a63acd]";
    case "หวยหุ้น":
      return "bg-[#a63acd]";
    case "หวยไทย":
      return "bg-[#3e8bff]";
    case "หวย JACKPOT 6 ตัว":
      return "bg-[#b3853e]";
    case "หวย JACKPOT 4-5 ตัว":
      return "bg-[#b3853e]";
    default:
      return "";
  }
};
const getColorBody = (name) => {
  switch (name) {
    case "จับยี่กี":
      return "bg-[#ffe8d6]";
    case "จับยี่กี 5G":
      return "bg-[#ffe8d6]";
    case "จับยี่กี 12 ราศี":
      return "bg-[#ffe8d6]";
    case "หวยรัฐบาลไทย":
      return "bg-[#cfebff]";
    case "หวยออมสิน":
      return "bg-[#ffc9e1]";
    case "หวยออมสินพิเศษ 1 ปี":
      return "bg-[#ffc9e1]";
    case "หวยออมสินพิเศษ 2 ปี":
      return "bg-[#ffc9e1]";
    case "หวย ธกส":
      return "bg-[#d6d5ff]";
    case "หวยฮานอย":
      return "bg-[#e8fff7]";
    case "หวยฮานอย VIP":
      return "bg-[#e8fff7]";
    case "หวยฮานอยพิเศษ":
      return "bg-[#e8fff7]";
    case "หวยฮานอย 5G":
      return "bg-[#e8fff7]";
    case "หวยฮานอย 4D":
      return "bg-[#e8fff7]";
    case "หวยมาเลย์":
      return "bg-[#e8fff7]";
    case "หวยลาว":
      return "bg-[#e8fff7]";
    case "หวยลาวสตาร์":
      return "bg-[#e8fff7]";
    case "หวยลาวจำปาศักดิ์":
      return "bg-[#e8fff7]";
    case "หวยหุ้นจีนรอบเช้า":
      return "bg-[#f6dcff]";
    case "หวยหุ้นจีนรอบบ่าย":
      return "bg-[#f6dcff]";
    case "หวยหุ้นฮั่งเส็งรอบเช้า":
      return "bg-[#f6dcff]";
    case "หวยหุ้นฮั่งเส็งรอบบ่าย":
      return "bg-[#f6dcff]";
    case "หวยหุ้นนิเคอิรอบเช้า":
      return "bg-[#f6dcff]";
    case "หวยหุ้นนิเคอิรอบบ่าย":
      return "bg-[#f6dcff]";
    case "หวยหุ้นดาวน์โจน":
      return "bg-[#f6dcff]";
    case "หวยหุ้นเกาหลี":
      return "bg-[#f6dcff]";
    case "หวยหุ้นไต้หวัน":
      return "bg-[#f6dcff]";
    case "หวยหุ้นเยอรมัน":
      return "bg-[#f6dcff]";
    case "หวยหุ้นรัสเซีย":
      return "bg-[#f6dcff]";
    case "หวยหุ้นสิงคโปร์":
      return "bg-[#f6dcff]";
    case "หวยหุ้นอังกฤษ":
      return "bg-[#f6dcff]";
    case "หวยหุ้นอินเดีย":
      return "bg-[#f6dcff]";
    case "หวยหุ้นอียิปต์":
      return "bg-[#f6dcff]";
    case "หวยหุ้น":
      return "bg-[#f6dcff]";
    case "หวยไทย":
      return "bg-[#cfebff]";
    case "หวย JACKPOT 6 ตัว":
      return "bg-[#f8eede]";
    case "หวย JACKPOT 4-5 ตัว":
      return "bg-[#f8eede]";
    default:
      return "";
  }
};
const getColorText = (name) => {
  switch (name) {
    case "จับยี่กี":
      return "text-[#ff943e]";
    case "จับยี่กี 5G":
      return "text-[#ff943e]";
    case "จับยี่กี 12 ราศี":
      return "text-[#ff943e]";
    case "หวยรัฐบาลไทย":
      return "text-[#3e8bff]";
    case "หวยออมสิน":
      return "text-[#e73583]";
    case "หวยออมสินพิเศษ 1 ปี":
      return "text-[#e73583]";
    case "หวยออมสินพิเศษ 2 ปี":
      return "text-[#e73583]";
    case "หวย ธกส":
      return "text-[#4343a5]";
    case "หวยฮานอย":
      return "text-[#01a163]";
    case "หวยฮานอย VIP":
      return "text-[#01a163]";
    case "หวยฮานอยพิเศษ":
      return "text-[#01a163]";
    case "หวยฮานอย 5G":
      return "text-[#01a163]";
    case "หวยฮานอย 4D":
      return "text-[#01a163]";
    case "หวยมาเลย์":
      return "text-[#01a163]";
    case "หวยลาว":
      return "text-[#01a163]";
    case "หวยลาวสตาร์":
      return "text-[#01a163]";
    case "หวยลาวจำปาศักดิ์":
      return "text-[#01a163]";
    case "หวยหุ้นจีนรอบเช้า":
      return "text-[#a63acd]";
    case "หวยหุ้นจีนรอบบ่าย":
      return "text-[#a63acd]";
    case "หวยหุ้นฮั่งเส็งรอบเช้า":
      return "text-[#a63acd]";
    case "หวยหุ้นฮั่งเส็งรอบบ่าย":
      return "text-[#a63acd]";
    case "หวยหุ้นนิเคอิรอบเช้า":
      return "text-[#a63acd]";
    case "หวยหุ้นนิเคอิรอบบ่าย":
      return "text-[#a63acd]";
    case "หวยหุ้นดาวน์โจน":
      return "text-[#a63acd]";
    case "หวยหุ้นเกาหลี":
      return "text-[#a63acd]";
    case "หวยหุ้นไต้หวัน":
      return "text-[#a63acd]";
    case "หวยหุ้นเยอรมัน":
      return "text-[#a63acd]";
    case "หวยหุ้นรัสเซีย":
      return "text-[#a63acd]";
    case "หวยหุ้นสิงคโปร์":
      return "text-[#a63acd]";
    case "หวยหุ้นอังกฤษ":
      return "text-[#a63acd]";
    case "หวยหุ้นอินเดีย":
      return "text-[#a63acd]";
    case "หวยหุ้นอียิปต์":
      return "text-[#a63acd]";
    case "หวยหุ้น":
      return "text-[#a63acd]";
    case "หวยไทย":
      return "text-[#3e8bff]";
    case "หวย JACKPOT 6 ตัว":
      return "text-[#b3853e]";
    case "หวย JACKPOT 4-5 ตัว":
      return "text-[#b3853e]";
    default:
      return "";
  }
};

export { getColorCard, getColorBody, getColorText, getIconHuay };
